// src/config/about/content.js

export const aboutContent = {
  hero: {
    title: "Engineering Excellence, Global Service",
    subtitle:
      "Built on 20 years of manufacturing heritage, we define the future of abrasive machinery through the synergy of ABR® hardware and YOLEE® professional services.",
  },

  intro: {
    title: "ABR® & YOLEE®",
    subtitle: "Hardware Reliability Meets Professional Expertise",
    text1:
      "Our story began in 2005 with the founding of Zhengzhou Shixiao Machinery by Mr. Wu Xinyue. For nearly two decades, we have focused on the relentless improvement of abrasive production technology. In 2019, to better serve the evolving global market, we launched <strong>ABR®</strong> as our dedicated machinery brand and <strong>YOLEE®</strong> as our professional global sales and service organization.",
    text2:
      "While <strong>ABR®</strong> represents the rugged, high-precision machines that leave our factory floor, <strong>YOLEE®</strong> is the soul of our international operations. YOLEE® adds the essential 'Software' to ABR® hardware—providing technical consultation, international compliance, customized engineering, and a seamless procurement experience for clients worldwide.",
  },

  factory: {
    title: "The Backbone of ABR® Machinery",
    lead: "Every ABR® machine is a product of highly regulated, in-house manufacturing. We are unique in the domestic industry for possessing a complete suite of high-end processing equipment, ensuring that the foundation of our machinery is built with unmatched precision.",
    strengths: [
      "Full-Scale Gantry Machining Centers: We are among the very few in China to own these, ensuring absolute structural integrity for heavy-duty chassis.",
      "High-Precision CNC Machining Centers: Enabling complex component fabrication with micron-level tolerances.",
      "Ultra-Accurate Laser Cutting: Ensuring perfect geometry for modular assembly and seamless mechanical fit.",
      "In-House Control: By owning the entire high-end machining lineup, we maintain 100% quality control that outsourced factories simply cannot match.",
    ],
  },

  history: [
    {
      year: "2005",
      title: "Factory Foundation",
      text: "Founded by Mr. Wu Xinyue as Zhengzhou Shixiao Machinery Co., Ltd., establishing a commitment to durable and honest mechanical solutions.",
    },
    {
      year: "2008",
      title: "Product Line Expansion",
      text: "Successfully completed full-process equipment sets for both Abrasive Belt conversion and Flap Disc manufacturing.",
    },
    {
      year: "2013",
      title: "The Milestone Leap",
      text: "Launched China’s first 3-in-1 automatic skiving machine (integrating grinding, gluing, and filming). This revolutionized efficiency by replacing manual labor with a continuous automated motion.",
    },
    {
      year: "2016",
      title: "Modernization & Scale",
      text: "Relocated to a larger facility and introduced advanced CNC machining centers, establishing a foundation for export-grade stability.",
    },
    {
      year: "2019",
      title: "Brand Birth & Strategic Learning",
      text: "Launched ABR® and YOLEE® to serve high-end international markets. In our pursuit of excellence, we have always looked to industry pioneers like Amacker + Schmid AG (Switzerland), BIKO (Italy), and METIS (Italy) as benchmarks, continuously learning from their standards to elevate our own technical soul.",
    },
    {
      year: "2021",
      title: "Precision Revolution",
      text: "Introduced Gantry Machining Centers and Laser Cutting. Fully upgraded the 'Flap Disc Forming' equipment, elevating both electrical systems and chassis stability to world-class tiers.",
    },
    {
      year: "2024",
      title: "Standardized Industrial Site",
      text: "Doubled facility footprint to create a strictly regulated site. Fully separated zones for design, CNC, assembly, and testing ensure maximum quality control.",
    },
  ],

  yoleeRole: {
    title: "YOLEE® — Your Gateway to ABR® Solutions",
    intro1:
      "<strong>YOLEE®</strong> is not just a sales company; we are the professional service arm that empowers the ABR® brand on the global stage.",
    intro2:
      "When you partner with YOLEE®, you are choosing an engineering-led sales team that understands the nuances of international trade and industrial standards. We ensure that the ABR® machines you receive are perfectly configured for your local market and backed by reliable, long-term support.",
    brandLink: {
      text: "Discover the ABR® machinery manufacturing portal:",
      url: "https://www.abrmachinery.com",
      label: "www.abrmachinery.com",
    },
    cards: [
      {
        title: "Professional Sales",
        text: "Our sales engineers bridge the gap between complex manufacturing and your specific production needs with clear, technical communication.",
      },
      {
        title: "Service Integration",
        text: "Beyond the machine, YOLEE® provides the 'Content'—including technical documentation, CE compliance, and global logistics management.",
      },
      {
        title: "Lifecycle Partnership",
        text: "We manage the entire lifecycle of your ABR® equipment, from initial customization and commissioning to global spare part supply.",
      },
    ],
  },
};
